<mat-expansion-panel
  class="skill"
  [expanded]="true"
  [hideToggle]="false"
>
  <mat-expansion-panel-header>
    <mat-panel-title class="mat-body">
      {{ groupName | mojoHighlight: keywords }}
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div class="skills">
      <div *ngFor="let skill of skills; let i = index; trackBy: trackElement">
        <div
          class="row"
          *ngIf="i % 3 === 0"
        >
          <div class="col-md-4">
            {{ skill?.name | mojoHighlight: keywords }}
          </div>
          <div class="col-md-4">
            {{ skills[i+1]?.name | mojoHighlight: keywords }}
          </div>
          <div class="col-md-4">
            {{ skills[i+2]?.name | mojoHighlight: keywords }}
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</mat-expansion-panel>
